import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const KpiHistoryChart = ({ data, title, dataKey, strokeColor = '#8884d8', unit = '' }) => {
    // Detect theme based on the class on the html element, which is how TailwindCSS manages dark mode.
    const isDarkMode = document.documentElement.classList.contains('dark');
    const theme = isDarkMode ? 'dark' : 'light';

    const tickColor = theme === 'light' ? '#475569' : '#94a3b8';
    const gridColor = theme === 'light' ? '#e2e8f0' : '#334155';

    if (!data || data.length === 0) {
        return (
            <div className="flex items-center justify-center h-64 bg-slate-50 dark:bg-slate-800/50 rounded-lg">
                <p className="text-slate-500 dark:text-slate-400">Aguardando novos dados para exibir o histórico...</p>
            </div>
        );
    }

    return (
        <div className="p-4 bg-slate-100 dark:bg-slate-800/50 rounded-2xl shadow-lg h-80">
            <h3 className="text-lg font-semibold mb-4 text-slate-700 dark:text-slate-200">{title}</h3>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={data}
                    margin={{
                        top: 5,
                        right: 20,
                        left: -10,
                        bottom: 20,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
                    <XAxis 
                        dataKey="time" 
                        stroke={tickColor} 
                        tick={{ fontSize: 12 }}
                    />
                    <YAxis 
                        stroke={tickColor} 
                        tick={{ fontSize: 12 }}
                        domain={['dataMin - 1', 'dataMax + 1']}
                        allowDecimals={false}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: theme === 'light' ? '#ffffff' : '#1e293b',
                            borderColor: theme === 'light' ? '#e2e8f0' : '#334155',
                            borderRadius: '0.5rem',
                        }}
                        formatter={(value) => [`${value}${unit}`, title]}
                        labelStyle={{ color: tickColor }}
                    />
                    <Line 
                        type="monotone" 
                        dataKey={dataKey} 
                        stroke={strokeColor}
                        strokeWidth={2}
                        dot={false}
                        activeDot={{ r: 6, strokeWidth: 0 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default KpiHistoryChart;
